import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import { AnyAction } from 'redux'
import { Application } from '../../../config'
import { Page } from '../../../components'
import { images } from '../../../images'
import { appsStyleSelected } from '../../../helpers/app'
import TermsAndConditionsText, { termsUrl } from '../../../containers/TermsAndConditionsText'
import { AuthenticatedRoutable } from '../../../models'
import literalsService from '../../../services/literals-service'
import StyledArticle from './styles'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {}

const { isAmb } = Application

class Terms extends AuthenticatedRoutable<IProps> {

  // AMB also points at the page where the full document lives.
  private get ambVisit(): ReactNode {
    return (
      <>
        { '\n\n' }
        { literalsService.get('visit') + ' ' }
        <span className="link" onClick={ this.goToTerms }>{ termsUrl() }</span>
        { ' ' + literalsService.get('goToTab') + '.' }
      </>
    )
  }

  public componentDidMount(): void {
    super.componentDidMount()
  }

  public render(): ReactNode {
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
            <h3>{ literalsService.get('termsTitle', true) }</h3>
            <p className="text">
              <TermsAndConditionsText />
              { isAmb && this.ambVisit }
            </p>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private goToTerms = (): void => {
    window.open(termsUrl(), '_blank')
  }
}

export default connect()(Terms)
